import Facets from '../components/Facets';
import MobileFilterDrawer from '../components/MobileFilterDrawer';
import initViewMorePagination from '../components/ViewMorePagination';

export default class MainCollection {
  constructor() {
    Facets();
    initViewMorePagination();
    new MobileFilterDrawer();
  }
}
